import { BaseService } from './base.service';

export default class DeviceRegistrationService extends BaseService {
  public async registerPolarUser(code: string) {
    return this.axios.post(`${this.backendUrl}/polar/registration`, { code });
  }

  public async deregisterPolarUser() {
    return this.axios.delete(`${this.backendUrl}/polar/registration`);
  }

  public async getGarminUnauthorizedRequestToken() {
    return this.axios.post(`${this.backendUrl}/garmin/token`, {});
  }

  public async registerGarminUser(verifier: string) {
    return this.axios.post(`${this.backendUrl}/garmin/registration`, { verifier });
  }

  public async deregisterGarminUser() {
    return this.axios.delete(`${this.backendUrl}/garmin/registration`);
  }

  public async registerSuuntoUser(code: string) {
    return this.axios.post(`${this.backendUrl}/suunto/registration`, { code });
  }

  public async registerStravaUser(code: string) {
    return this.axios.post(`${this.backendUrl}/strava/registration`, { code });
  }

  public async deregisterStravaUser() {
    return this.axios.delete(`${this.backendUrl}/strava/registration`);
  }

  public async registerCorosUser(code: string) {
    return this.axios.post(
      `${this.backendUrl}/coros/registration`,
      { code },
      { headers: { 'X-Redirect': 'https://app.coelab.co/coros/registration' } }
    );
  }

  public async deregisterCorosUser() {
    return this.axios.delete(`${this.backendUrl}/coros/registration`);
  }
}
